import axios from '@/libs/api.request'

export const getHomeInfo = () => {
  return axios.request({
    url: '/home/info',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/home.js